import {FC} from 'react'
import {useIntl} from 'react-intl'

const Error404: FC = () => {
  const intl = useIntl()
  return (
    <>
      <h1 className='fw-bolder fs-4x text-gray-700 mb-10'>
        {intl.formatMessage({id: 'PAGE.NOT_FOUND'})}
      </h1>

      <div className='fw-bold fs-3 text-gray-400 mb-15'>
        {intl.formatMessage({id: 'PAGE.NOT_FOUND_TEXT'})}
        <br />
      </div>
    </>
  )
}

export {Error404}
